import { Tooltip, OverlayTrigger } from 'react-bootstrap'

export const NewTooltip = ({
                                children,
                                text,
                                placement = 'top',
                                delay = { show: 250, hide: 200 },
                                className = '',
                            }) => (
    <OverlayTrigger
        placement={placement}
        delay={delay}
        overlay={<Tooltip id="tooltip" className={className}>{text}</Tooltip>}
    >
        {children}
    </OverlayTrigger>
)
